import { render, staticRenderFns } from "./CustomTableWrapper.vue?vue&type=template&id=5d5cb639&scoped=true&"
import script from "./CustomTableWrapper.vue?vue&type=script&lang=ts&"
export * from "./CustomTableWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./CustomTableWrapper.vue?vue&type=style&index=0&id=5d5cb639&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5cb639",
  null
  
)

export default component.exports